import { cssMap } from '@atlaskit/css';

import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';

import { token } from '@atlaskit/tokens';

import { keyframes, styled } from '@compiled/react';

import { type JSX } from 'react/jsx-runtime';

type LoadingSkeletonProps = {
	width: string;
	height: string;
	borderRadius: string;
};

const shimmer = keyframes({
	'0%': {
		backgroundPosition: '-300px 0',
	},
	'100%': {
		backgroundPosition: '1000px 0',
	},
});

const LoadingSkeleton = styled.div<LoadingSkeletonProps>(({ width, borderRadius, height }) => ({
	animationDuration: '1.2s',
	animationFillMode: 'forwards',
	animationIterationCount: 'infinite',
	animationName: shimmer,
	animationTimingFunction: 'linear',
	backgroundColor: token('color.skeleton', 'grey'),
	backgroundImage: `linear-gradient( to right, ${token('color.skeleton', 'grey')} 10%, ${token('color.skeleton.subtle', 'grey')} 20%, ${token('color.skeleton', 'grey')} 30% )`,
	backgroundRepeat: 'no-repeat',
	borderRadius: borderRadius,
	height: height,
	width: width,
	marginRight: 0,
	marginTop: 0,
	marginBottom: 0,
	marginLeft: 0,
}));

const styles = cssMap({
	cardContainer: {
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.medium'),
		minWidth: '342px',
		flex: '1 1 0',
	},
});

export const TemplateCardLoader = (): JSX.Element => (
	<Box backgroundColor="elevation.surface" padding="space.300" xcss={styles.cardContainer}>
		<Stack alignBlock="center" alignInline="center" grow="hug" space="space.300">
			<LoadingSkeleton width="294px" height="224px" borderRadius="3px" />
			<Stack space="space.200">
				<Stack space="space.100">
					<LoadingSkeleton width="238px" height="20px" borderRadius="3px" />
					<LoadingSkeleton width="318px" height="40px" borderRadius="3px" />
				</Stack>
				<Inline spread="space-between" alignBlock="center">
					<LoadingSkeleton width="171px" height="24px" borderRadius="3px" />
					<LoadingSkeleton width="107px" height="32px" borderRadius="3px" />
				</Inline>
			</Stack>
		</Stack>
	</Box>
);
